import React, { useEffect, useRef, useState } from "react";
import '../../../sass/components/flexibleModules/homepage/_components.HomepageIconsDescriptionModule.scss';

const HomepageIconsDescriptionModule = ({ data }) => {

    // const [fixedImage, setFixedImage] = useState(data.homepageIconsDescriptionModuleRepeaterSections[0]);
    const [fixedImageClassOne, setFixedImageClassOne] = useState('is-active');
    const [fixedImageClassTwo, setFixedImageClassTwo] = useState('inactive');
    const [fixedImageClassThree, setFixedImageClassThree] = useState('inactive');
    const [fixedImageClassFour, setFixedImageClassFour] = useState('inactive');
    const [mainImageClass, setMainImageClass] = useState("l-topInitial");

    const contentRef = useRef(null);

    let imagesScroll = false;

    let mediaQueryMax = null;
    let mediaQueryMin = null;
    if (typeof window !== "undefined") {
        mediaQueryMax = window.matchMedia("(max-width: 767px)");
        mediaQueryMin = window.matchMedia("(min-width: 768px)");
        if (mediaQueryMax.matches) {
            imagesScroll = true;
        }
        else {
            imagesScroll = false;
        }
    }

    // useEffect(() => {        

    // }, []);

    if(typeof window !== "undefined"){
        if (window.innerWidth > 767) {
            window.addEventListener("scroll", function () {
                if (document.querySelector(".cp-homepageIconsDescriptionModule")) {
                    if (document.documentElement.scrollTop > document.querySelector(".cp-homepageIconsDescriptionModule").offsetTop) {
                        handleScroll();
                    }
                }
            });
        }
    }

    const handleScroll = (e) => {
        const leftDiv = contentRef.current;
        if (!leftDiv) return;
        
        if (leftDiv) {
            const scrollTop = 0 - leftDiv.getBoundingClientRect().top;
            if (scrollTop > -650 && scrollTop < 0) {
                setFixedImageClassOne('is-active');
                setFixedImageClassTwo('inactive');
                setFixedImageClassThree('inactive');
                setFixedImageClassFour('inactive');
                setMainImageClass("l-topInitialOne");
            }
            else if (scrollTop > -650 && scrollTop < 100) {
                setFixedImageClassOne('is-hyperactiveOne');
                setFixedImageClassTwo('is-preactiveOne');
                setFixedImageClassThree('inactive');
                setFixedImageClassFour('inactive');
            }
            else if (scrollTop > -650 && scrollTop < 200) {
                setFixedImageClassOne('is-hyperactiveTwo');
                setFixedImageClassTwo('is-preactiveTwo');
                setFixedImageClassThree('inactive');
                setFixedImageClassFour('inactive');
            }
            else if (scrollTop > -650 && scrollTop < 300) {
                setFixedImageClassOne('is-hyperactiveThree');
                setFixedImageClassTwo('is-preactiveThree');
                setFixedImageClassThree('inactive');
                setFixedImageClassFour('inactive');
                setMainImageClass("l-topInitialTwo");
            }
            else if (scrollTop > -650 && scrollTop < 360) {
                setFixedImageClassOne('is-hyperactiveFour');
                setFixedImageClassTwo('is-preactiveFour');
                setFixedImageClassThree('inactive');
                setFixedImageClassFour('inactive');
            }

            else if (scrollTop < 450 && scrollTop > 360) {
                setFixedImageClassOne('inactive');
                setFixedImageClassTwo('is-active');
                setFixedImageClassThree('inactive');
                setFixedImageClassFour('inactive');
            }
            else if (scrollTop < 550 && scrollTop > 360) {
                setFixedImageClassOne('inactive');
                setFixedImageClassTwo('is-hyperactiveOne');
                setFixedImageClassThree('is-preactiveOne');
                setFixedImageClassFour('inactive');
                setMainImageClass("l-topInitialThree");
            }
            else if (scrollTop < 650 && scrollTop > 360) {
                setFixedImageClassOne('inactive');
                setFixedImageClassTwo('is-hyperactiveTwo');
                setFixedImageClassThree('is-preactiveTwo');
                setFixedImageClassFour('inactive');
            }
            else if (scrollTop < 800 && scrollTop > 360) {
                setFixedImageClassOne('inactive');
                setFixedImageClassTwo('is-hyperactiveThree');
                setFixedImageClassThree('is-preactiveThree');
                setFixedImageClassFour('inactive');
            }

            else if (scrollTop < 900 && scrollTop > 360) {
                setFixedImageClassOne('inactive');
                setFixedImageClassTwo('is-hyperactiveFour');
                setFixedImageClassThree('is-preactiveFour');
                setFixedImageClassFour('inactive');
                setMainImageClass("l-topInitialFour");
            }


            else if (scrollTop < 1000 && scrollTop > 900) {
                setFixedImageClassOne('inactive');
                setFixedImageClassTwo('inactive');
                setFixedImageClassThree('is-active');
                setFixedImageClassFour('inactive');
            }
            else if (scrollTop < 1100 && scrollTop > 900) {
                setFixedImageClassOne('inactive');
                setFixedImageClassTwo('inactive');
                setFixedImageClassThree('is-hyperactiveOne');
                setFixedImageClassFour('is-preactiveOne');
                setMainImageClass("l-topInitialFive");
            }
            else if (scrollTop < 1240 && scrollTop > 900) {
                setFixedImageClassOne('inactive');
                setFixedImageClassTwo('inactive');
                setFixedImageClassThree('is-hyperactiveTwo');
                setFixedImageClassFour('is-preactiveTwo');
            }
            else if (scrollTop < 1350 && scrollTop > 900) {
                setFixedImageClassOne('inactive');
                setFixedImageClassTwo('inactive');
                setFixedImageClassThree('is-hyperactiveThree');
                setFixedImageClassFour('is-preactiveThree');
                setMainImageClass("l-topInitialSix");
            }

            else if (scrollTop < 1440 && scrollTop > 900) {
                setFixedImageClassOne('inactive');
                setFixedImageClassTwo('inactive');
                setFixedImageClassThree('is-hyperactiveFour');
                setFixedImageClassFour('is-preactiveFour');
            }

            else if (scrollTop < 1540 && scrollTop > 1440) {
                setFixedImageClassOne('inactive');
                setFixedImageClassTwo('inactive');
                setFixedImageClassThree('inactive');
                setFixedImageClassFour('is-settingInActiveOne');
                setMainImageClass("l-topInitialSeven");
            }
            else if (scrollTop < 1640 && scrollTop > 1440) {
                setFixedImageClassOne('inactive');
                setFixedImageClassTwo('inactive');
                setFixedImageClassThree('inactive');
                setFixedImageClassFour('is-settingInActiveTwo');
                setMainImageClass("l-topInitialSeven");
            }
            else if (scrollTop < 1740 && scrollTop > 1440) {
                setFixedImageClassOne('inactive');
                setFixedImageClassTwo('inactive');
                setFixedImageClassThree('inactive');
                setFixedImageClassFour('is-settingInActiveThree');
                setMainImageClass("l-topInitialSeven");
            }
            else if (scrollTop < 1840 && scrollTop > 1440) {
                setFixedImageClassOne('inactive');
                setFixedImageClassTwo('inactive');
                setFixedImageClassThree('inactive');
                setFixedImageClassFour('is-settingInActiveFour');
                setMainImageClass("l-topInitialSeven");
            }
            else if (scrollTop < 2040 && scrollTop > 1440) {
                setFixedImageClassOne('inactive');
                setFixedImageClassTwo('inactive');
                setFixedImageClassThree('inactive');
                setFixedImageClassFour('is-settingInActiveFive');
                setMainImageClass("l-topInitialSeven");
            }
            else {
                return;
            }
        }
    };

    return (
        <div className={`cp-homepageIconsDescriptionModule ${mainImageClass} cp-allBrowsers`}>
            <div className="cp-homepageIconsDescriptionModule__inner" style={{ maxWidth: `${data.maxWidth}px`, margin: "0 auto" }}>
                {data.homepageIconsDescriptionModuleHeader &&
                    <>
                        <h2 data-sal="slide-up" data-sal-duration="800" data-sal-delay="300" data-sal-easing="ease">{data.homepageIconsDescriptionModuleHeader}</h2>
                        <span data-sal="slide-up" data-sal-duration="800" data-sal-delay="300" data-sal-easing="ease" className="l__divider"></span>
                    </>
                }
                {data.homepageIconsDescriptionModuleRepeaterSections &&
                    <div className="cp-homepageIconsDescriptionModule__sections">
                        <div className="cp-homepageIconsDescriptionModule__sections-section l--flex">
                            <div className="cp-homepageIconsDescriptionModule__sections-sectionLeft">
                                {!imagesScroll &&
                                    <div className="cp-homepageIconsDescriptionModule__sections-sec l--flex">
                                        <div className={`l__icon ${fixedImageClassOne}`}>
                                            {data.homepageIconsDescriptionModuleRepeaterSections[0].repeaterSectionsIcon &&
                                                <img loading="lazy" src={data.homepageIconsDescriptionModuleRepeaterSections[0].repeaterSectionsIcon.sourceUrl} alt={data.homepageIconsDescriptionModuleRepeaterSections[0].repeaterSectionsIcon.altText} />
                                            }
                                        </div>
                                        <div className={`l__icon ${fixedImageClassTwo}`}>
                                            {data.homepageIconsDescriptionModuleRepeaterSections[1].repeaterSectionsIcon &&
                                                <img loading="lazy" src={data.homepageIconsDescriptionModuleRepeaterSections[1].repeaterSectionsIcon.sourceUrl} alt={data.homepageIconsDescriptionModuleRepeaterSections[1].repeaterSectionsIcon.altText} />
                                            }
                                        </div>
                                        <div className={`l__icon ${fixedImageClassThree}`}>
                                            {data.homepageIconsDescriptionModuleRepeaterSections[2].repeaterSectionsIcon &&
                                                <img loading="lazy" src={data.homepageIconsDescriptionModuleRepeaterSections[2].repeaterSectionsIcon.sourceUrl} alt={data.homepageIconsDescriptionModuleRepeaterSections[2].repeaterSectionsIcon.altText} />
                                            }
                                        </div>
                                        <div className={`l__icon ${fixedImageClassFour}`}>
                                            {data.homepageIconsDescriptionModuleRepeaterSections[3].repeaterSectionsIcon &&
                                                <img loading="lazy" src={data.homepageIconsDescriptionModuleRepeaterSections[3].repeaterSectionsIcon.sourceUrl} alt={data.homepageIconsDescriptionModuleRepeaterSections[3].repeaterSectionsIcon.altText} />
                                            }
                                        </div>
                                    </div>
                                }
                                {imagesScroll &&
                                    <>
                                        {
                                            data.homepageIconsDescriptionModuleRepeaterSections.map((iconSection, index) => (
                                                <div className="cp-homepageIconsDescriptionModule__sections-sec l--mobile l--flex" key={index}>
                                                    {index === 0 &&
                                                        <>
                                                            <div className="l__icon" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease">
                                                                {iconSection.repeaterSectionsIcon &&
                                                                    <img loading="lazy" src={iconSection.repeaterSectionsIcon.sourceUrl} alt={iconSection.repeaterSectionsIcon.altText} />
                                                                }
                                                            </div>
                                                        </>
                                                    }
                                                    {index === 1 &&
                                                        <>
                                                            <div className="l__icon" data-sal="zoom-in" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease">
                                                                {iconSection.repeaterSectionsIcon &&
                                                                    <img loading="lazy" src={iconSection.repeaterSectionsIcon.sourceUrl} alt={iconSection.repeaterSectionsIcon.altText} />
                                                                }
                                                            </div>
                                                        </>
                                                    }
                                                    {index === 2 &&
                                                        <>
                                                            <div className="l__icon" data-sal="zoom-in" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease">
                                                                {iconSection.repeaterSectionsIcon &&
                                                                    <img loading="lazy" src={iconSection.repeaterSectionsIcon.sourceUrl} alt={iconSection.repeaterSectionsIcon.altText} />
                                                                }
                                                            </div>
                                                        </>
                                                    }
                                                    {index === 3 &&
                                                        <>
                                                            <div className="l__icon" data-sal="flip-right" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease">
                                                                {iconSection.repeaterSectionsIcon &&
                                                                    <img loading="lazy" src={iconSection.repeaterSectionsIcon.sourceUrl} alt={iconSection.repeaterSectionsIcon.altText} />
                                                                }
                                                            </div>
                                                        </>
                                                    }
                                                    <div className="l__content" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease">
                                                        {iconSection.repeaterSectionsHeader &&
                                                            <h4>{iconSection.repeaterSectionsHeader}</h4>
                                                        }
                                                        {iconSection.repeaterSectionsTeaser &&
                                                            <p dangerouslySetInnerHTML={{ __html: iconSection.repeaterSectionsTeaser }} />
                                                        }
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </>
                                }
                            </div>
                            <div className="cp-homepageIconsDescriptionModule__sections-sectionRight" ref={contentRef}>
                                {data.homepageIconsDescriptionModuleRepeaterSections.map((iconSection, index) => (
                                    <div className="cp-homepageIconsDescriptionModule__sections-sec l--flex" key={index}>
                                        <div className="l__content" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease">
                                            {iconSection.repeaterSectionsHeader &&
                                                <h4>{iconSection.repeaterSectionsHeader}</h4>
                                            }
                                            {iconSection.repeaterSectionsTeaser &&
                                                <p dangerouslySetInnerHTML={{ __html: iconSection.repeaterSectionsTeaser }} />
                                            }
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div >
    );
}

export default HomepageIconsDescriptionModule;